import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cohrex-spinner',
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SpinnerComponent {
  @Input() className: string = '';
}
